<!-- 各保险公司定损标准(元/亩) -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let SettlementFeeStandardChart = null;
export default {
	name: 'SettlementFeeStandardChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'SettlementFeeStandardChart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			//  id: 'SettlementFeeStandardChart',//地图渲染容器id
			option: {
				title: {
					text: '',
					subtext: '（2020年4月26日）',
					left: 'right'
				},
				tooltip: {
					trigger: 'axis'
				},
				//超出范围滚动条设置
				dataZoom: [{
				  type: 'slider',
				  show: false, //flase直接隐藏图形
				  xAxisIndex: [0],
				  left: '9%', //滚动条靠左侧的百分比
				  bottom: -5,
				  start: 0,//滚动条的起始位置
				  end: 50 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
				}],
				dataset: {
					// dimensions: ['area', '确权面积', '水稻政策性保险', '玉米政策性保险', '大豆政策性保险'],
					// source: [
					//   { area: '哈尔滨市', '确权面积': 1000, '水稻政策性保险': 1500, '玉米政策性保险': 1200, '大豆政策性保险': 1200,'政策性保险合计':3900 },
					//   { area: '齐齐哈尔市', '确权面积': 2000, '水稻政策性保险': 1800, '玉米政策性保险': 1600, '大豆政策性保险': 1000,'政策性保险合计':4400 },
					//   { area: '鹤岗市', '确权面积': 5000, '水稻政策性保险': 2000, '玉米政策性保险': 3000, '大豆政策性保险': 1489,'政策性保险合计':6489},
					//   { area: '双鸭山市', '确权面积': 10000, '水稻政策性保险': 2000, '玉米政策性保险': 3000, '大豆政策性保险': 1489,'政策性保险合计':6489},
					//   { area: '鸡西市', '确权面积': 8000, '水稻政策性保险': 5000, '玉米政策性保险': 8000, '大豆政策性保险': 1600,'政策性保险合计':14600 },
					// ]
				},
				legend: {
					top: 0,
					itemGap: 20,
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
					  color: "#333"
					},
					icon: 'rect'
					// data: ["水稻政策性保险", "玉米政策性保险", "大豆政策性保险", "确权面积"]
				},
				grid: {
					left:60,
					right:10
				},
				toolbox: {
					show: true
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						//data: ['永安保险', '华安保险', '大众保险', '人民保险', '天安保险', '人寿保险', '阳光保险', '太平洋保险', '华泰保险', '东方保险'],

						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#aaa',
								type: 'dotted'
							}
						},
						axisLabel: {
							color: '#333',
							interval:0,
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dotted'
							}
						},
						axisLine: {
							show: false
						}
						// axisLabel: {
						//   formatter (val) {
						//     if (val >= 10000) {
						//       return val / 10000 + "万";
						//     } else return val;
						//   }
						// }
					}
				],
				color: ["#1a8dee", "#4ab2e9", "#13cdcc","#ff9023",'#02C874', '#0000E3', '#8600FF', '#FFDC35', '#80FFFF', '#B766AD', '#FF60AF'],
				series: [
					{
						name: '',
						//data: [345433, 837575, 33858,643444,342358,243545,154523,834545,343425,735678],
						type: 'bar',
						barWidth: 14
					},
					{
						name: '',
						//data: [435623, 478865, 543677,453665,577431,868999,945365,3356788,443555,746632],
						type: 'bar',
						barWidth: 14
					},
					{
						name: '',
						//data: [643564, 512444, 233112,13346,842348,334111,5234532,6254655,9356776],
						type: 'bar',
						barWidth: 14
					},
					{
						name: '',
						//data: [643564, 512444, 233112,13346,842348,334111,5234532,6254655,9356776],
						type: 'bar',
						barWidth: 14
					},
					
				]
			}
		};
	},
	mounted() {
		// this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (SettlementFeeStandardChart) {
				SettlementFeeStandardChart.resize();
			}
		},

		initMap(optionData) {
			//设置时间
			//this.option.title.subtext = this.subtext || '';
			this.option.title.subtext = optionData.date+'年' || '';
			if (optionData.dataZoom) {
			  this.option.dataZoom[0].show = optionData.dataZoom
			}
			// this.option.legend.data = optionData.legend
			// this.option.color = optionData.color
			// this.option.xAxis.data = optionData.xAxis
			// this.option.series = optionData.series
			this.option.dataset = optionData.dataset || [];
			SettlementFeeStandardChart = echarts.init(document.getElementById(this.id));
			SettlementFeeStandardChart.setOption(this.option);
		}
	},

	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
	height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementFeeStandardChart.vue